import api from '../index';

// ================================General Setting Apis==================================
const settingBaseUrl = '/toggle';

export const getToggleSettingsApi = () => {
  return api({
    method: 'get',
    url: `${settingBaseUrl}/list`,
  });
};

export const updateToggleSettingsApi = (data) => {
  return api({
    method: 'put',
    url: `${settingBaseUrl}/update`,
    data,
  });
};
// ================================Notification Apis========================================
const notificationBaseUrl = '/notification';

export const getAllSettings = () => {
  return api({
    method: 'get',
    url: `${notificationBaseUrl}/get-notification-settings-list`,
  });
};

export const setUsertSettings = (settings) => {
  return api({
    method: 'post',
    url: `${notificationBaseUrl}/create-notification-settings`,
    data: settings,
  });
};
export const getUserNotificationsApi = () => {
  return api({
    method: 'get',
    url: `${notificationBaseUrl}/get-user-notifications`,
  });
};

export const readNotificationApi = (notifications) => {
  return api({
    method: 'post',
    url: `${notificationBaseUrl}/read-user-notifications`,
    data: notifications,
  });
};

export const viewNotificationApi = (notification) => {
  return api({
    method: 'put',
    url: `${notificationBaseUrl}/view-notification`,
    data: notification,
  });
};

export const clearNotificationApi = () => {
  return api({
    method: 'delete',
    url: `${notificationBaseUrl}/delete-notifications`,
  });
};
// ================================Matrixes Apis========================================
const matrixBaseUrl = '/pricingMatrix';

export const getAllMatrixesApi = () => {
  return api({
    method: 'get',
    url: `${matrixBaseUrl}/get-pricing-matrix`,
  });
};

export const addMatrixApi = (data) => {
  return api({
    method: 'post',
    url: `${matrixBaseUrl}/add-pricing-matrix`,
    data: data,
  });
};

export const updateMatrixApi = (data) => {
  return api({
    method: 'put',
    url: `${matrixBaseUrl}/update-pricing-matrix`,
    data: data,
  });
};

export const deleteMatrixApi = (id) => {
  return api({
    method: 'delete',
    url: `${matrixBaseUrl}/delete-pricing-matrix/${id}`,
  });
};
